import * as Filters from '@/lib/filters'
import Vue from 'vue'
import UserInfo from './user-info'

export default class PurchaseInfo {
  static get PLAN_FREE() {
    return 'Free'
  }
  static get PLAN_STANDARD() {
    return 'Standard'
  }
  static get VENDOR_GOOGLE() {
    return 'Google'
  }
  static get VENDOR_STRIPE() {
    return 'Stripe'
  }
  static get STATE_PAID() {
    return 'Paid'
  }
  static get STATE_NOT_PAID() {
    return 'NotPaid'
  }
  static get STATE_TRIAL() {
    return 'Trial'
  }
  static get STATE_CANCELED() {
    return 'Canceled'
  }

  // 初回取得するまでのdummy
  static dummy() {
    return new PurchaseInfo({
      plan: 'Free',
      billingVendor: 'Google',
      planStartedAt: null,
      planExpiredAt: null,
      planEnforced: true,
      trial: false,
      subscriptionId: null,
      autoRenewing: true,
      purchases: [],
      activeSubscriptionCount: 0,
      subscriptionIdForFunctionality: null,
    })
  }

  constructor(purchaseInfo) {
    if (!purchaseInfo) {
      throw new Error('purchaseInfo is null!')
    }
    this.purchaseInfo = purchaseInfo
  }

  isTrial() {
    return this.purchaseInfo.trial
  }

  isAutoRenewing() {
    return this.purchaseInfo.autoRenewing
  }

  getBillingVendor() {
    return this.purchaseInfo.billingVendor
  }

  isGoogle() {
    return PurchaseInfo.VENDOR_GOOGLE === this.getBillingVendor()
  }

  isStripe() {
    return PurchaseInfo.VENDOR_STRIPE === this.getBillingVendor()
  }

  getStartedAt() {
    return this.purchaseInfo.planStartedAt
  }

  getStartedDateFormatted() {
    const val = this.getStartedAt()
    if (val) {
      return Filters.aidToYearMonthDay(val)
    }
    return ''
  }

  getExpiredAt() {
    return this.purchaseInfo.planExpiredAt
  }

  getExpiredDateFormatted() {
    const val = this.getExpiredAt()
    if (val) {
      return Filters.aidToYearMonthDay(val)
    }
    return ''
  }

  getSubscriptionId() {
    return this.purchaseInfo.subscriptionId
  }

  getPurchases() {
    return this.purchaseInfo.purchases
  }

  getI18nName() {
    // 正式名は「AgriBus Professional」(2026-10-31)。旧 Plus は Professional に統合済みなので表示も同じ
    if (UserInfo.hasPlusFunctionality() || UserInfo.hasProfessionalFunctionality()) {
      return 'AgriBus Professional'
    }
    if (UserInfo.hasStandardFunctionality()) {
      return Vue.prototype.$tt('StandardPlanDisplayName')
    }
    return 'Free'
  }

  doesExistsExpiredAtValue() {
    if (!UserInfo.hasFreeFunctionality()) {
      let planExpiredAt = this.getExpiredAt()
      if (planExpiredAt) {
        return true
      }
    }
    return false
  }
  getI18nExpirationDate() {
    if (this.doesExistsExpiredAtValue()) {
      return Vue.prototype.$tt('customPlanExpirationDate', {
        expirationDate: Filters.aidToYearMonthDay(this.getExpiredAt()),
      })
    }
    return ''
  }
  isGoogleCanceled() {
    const purchaseInfo = this.purchaseInfo
    if (purchaseInfo) {
      if (this.isStripe()) return false
      const purchases = purchaseInfo.purchases
      if (purchases && purchases.length > 0) {
        const purchase = purchases[0]
        // Googleの場合、autoRenewingがfalse、かつstatusがcanceledの場合はtrue
        if (!purchase.autoRenewing) {
          return purchase.state === PurchaseInfo.STATE_CANCELED
        }
      }
    }
    return false
  }
}
